export const textEN = {
  completeds: 'Completed'
}
